import React from 'react';
import { Badge } from './badge';
import { cn } from '../../lib/utils';

/**
 * Payment Status Badge component using shadcn/ui Badge
 * @param {Object} props - Component props
 * @param {string} props.status - Payment status (INITIATED, PROCESSING, COMPLETED, FAILED)
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.showIcon - Whether to show status icon (default: true)
 * @returns {JSX.Element} PaymentStatusBadge component
 */
const PaymentStatusBadge = ({
  status,
  className = '',
  showIcon = false,
  ...props
}) => {
  // Get status configuration (show API values directly)
  const getStatusConfig = () => {
    const s = status?.toString()?.toUpperCase();
    switch (s) {
      case 'COMPLETED':
        return {
          label: 'COMPLETED',
          variant: 'outline',
          className: 'bg-green-100 text-green-800 border-green-200 hover:bg-green-200'
        };
      case 'PROCESSING':
        return {
          label: 'PROCESSING',
          variant: 'outline',
          className: 'bg-blue-100 text-blue-800 border-blue-200 hover:bg-blue-200'
        };
      case 'INITIATED':
        return {
          label: 'INITIATED',
          variant: 'outline',
          className: 'bg-yellow-100 text-yellow-800 border-yellow-200 hover:bg-yellow-200'
        };
      case 'FAILED':
        return {
          label: 'FAILED',
          variant: 'outline',
          className: 'bg-red-100 text-red-800 border-red-200 hover:bg-red-200'
        };
      default:
        return {
          label: s || 'UNKNOWN',
          variant: 'outline',
          className: 'bg-gray-100 text-gray-800 border-gray-200 hover:bg-gray-200'
        };
    }
  };

  const config = getStatusConfig();

  return (
    <Badge
      variant={config.variant}
      className={cn(
        'inline-flex items-center font-medium',
        config.className,
        className
      )}
      {...props}
    >
      {config.label}
    </Badge>
  );
};

export default PaymentStatusBadge;
